import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"py-3 pl-14 d-flex"},[_vm._m(0),_vm._t("titulo-lado-direito")],2),_c(VDivider)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"ma-0 font-24 font-weight-medium"},[_vm._v("Análise de cotação")]),_c('p',{staticClass:"ma-0 font-12 font-weight-medium"},[_vm._v("Selecione quais produtos de fornecedores você deseja comprar")])])
}]

export { render, staticRenderFns }